import { httpClient } from "@/utils/api"
import type { SuccessData } from "@/utils/api"
import { useMutation } from "@tanstack/react-query"
import type { UseMutationOptions } from "@tanstack/react-query"
import type { AxiosError, AxiosResponse } from "axios"

import type { User } from "../../models/user"

export interface ResendEmailError extends SuccessData {
  errors: string[]
}

export const resendEmailApi = async (
  email: User["email"]
): Promise<AxiosResponse<SuccessData>> => {
  return await httpClient.post("/users/confirmation", {
    user: { email: email },
  })
}

export const useResendEmail = (
  options: UseMutationOptions<
    AxiosResponse<SuccessData>,
    AxiosError<ResendEmailError>,
    User["email"]
  >
) => {
  const useMutationOptions = {
    ...options,
    mutationFn: async (email: User["email"]) => resendEmailApi(email),
  }

  const { data, isError, isPending, isSuccess, mutateAsync } =
    useMutation(useMutationOptions)

  return {
    resendEmail: mutateAsync,
    resendEmailData: data,
    resendEmailIsError: isError,
    resendEmailIsLoading: isPending,
    resendEmailIsPending: isPending,
    resendEmailIsSuccess: isSuccess,
  }
}
